import { Dispatch } from 'redux';

import { TagPayload } from '@/features/PCP/containers/FilterTagsContainer';
import { setPageNumber } from '@/store/redux/actions/pages/pcp';
import { VehicleConditionStateProps } from '@/store/redux/reducers/pages/pcp/filters/vehicleCondition';
import { IReduxActionProps } from '@/store/redux/Utils';

export const SET_VEHICLE_CONDITION_FILTER = 'SET_VEHICLE_CONDITION_FILTER';
export const DELETE_VEHICLE_CONDITION_FILTER =
  'DELETE_VEHICLE_CONDITION_FILTER';

export const RESET_VEHICLE_CONDITION_FILTER = 'RESET_VEHICLE_CONDITION_FILTER';

export const setFilterVehicleCondition = ({
  condition,
  mileage,
  minYear,
  maxYear,
  maxOwners,
  filterCount,
}: VehicleConditionStateProps) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: SET_VEHICLE_CONDITION_FILTER,
      payload: {
        condition,
        mileage,
        minYear,
        maxYear,
        maxOwners,
        filterCount,
      },
    });
  };
};

export const deleteFilterVehicleCondition = (payload: TagPayload) => {
  return (dispatch: Dispatch) => {
    dispatch(setPageNumber(1));

    dispatch({
      type: DELETE_VEHICLE_CONDITION_FILTER,
      payload,
    });
  };
};

export const resetVehicleConditionFilter = (): IReduxActionProps => {
  return {
    type: RESET_VEHICLE_CONDITION_FILTER,
  };
};
